import React from 'react'

import { FAB, FABProps, HoverEffectVariant, HoverIntensity, useRtl } from '@makyoapp/makyo-tw-ui'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useAppBuilderContext } from '@/context/AppBuilderContext'

export interface ICompFabProps {
  isHidden: boolean
  hAlign: string
  primaryActive: boolean
  secondaryActive: boolean
  primaryFab: FABProps
  secondaryFab: FABProps
  showNavbar: boolean
  navbarHeight: string
  hoverEffect?: HoverEffectVariant
  hoverIntensity?: HoverIntensity
}

export const CompFabCore: React.FC<ICompFabProps> = ({
  isHidden,
  hAlign,
  primaryActive,
  secondaryActive,
  primaryFab,
  secondaryFab,
  showNavbar,
  navbarHeight,
  hoverEffect,
  hoverIntensity,
}) => {
  const { isDevelopmentMode } = useAppBuilderContext()
  const dir = useRtl()
  const start = dir === 'ltr' ? { left: '16px' } : { right: '16px' }
  const end = dir === 'ltr' ? { right: '16px' } : { left: '16px' }

  const positionStyle = {
    start: start,
    center: { right: '50%', transform: 'translateX(50%)' },
    end: end,
  }[hAlign]

  return (
    <div
      style={{
        display: isHidden ? 'none' : undefined,
        // NOTE: for desktop is temporary until we fixed frame
        bottom: showNavbar ? `calc(${navbarHeight} + 16px)` : '16px',
        zIndex: 45,
        position: 'fixed' as const,
        ...positionStyle,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column' as const,
          gap: '8px',
          alignItems: hAlign,
        }}
      >
        {secondaryActive && (
          <FAB
            devMode={isDevelopmentMode}
            {...secondaryFab}
            align={hAlign}
            hoverEffect={hoverEffect}
            hoverIntensity={hoverIntensity}
          />
        )}
        {primaryActive && (
          <FAB
            devMode={isDevelopmentMode}
            {...primaryFab}
            align={hAlign}
            hoverEffect={hoverEffect}
            hoverIntensity={hoverIntensity}
          />
        )}
      </div>
    </div>
  )
}
